import BigNumber from "bignumber.js";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "../../../../../styles/reactnative";
import { COLORS } from "../../../../constants";
import { useTimezone } from "../../../../hooks/timezone";
import { TradeDetailListItemSection, TradeText } from "./styles";
import KrwPrice from "../../../../components/KrwPrice";
import dayjs from "dayjs";

const TradeDetailListItem = ({ item, index, dataType }: any) => {
  //const coin = item?.pairs?.split('/')[0]
  const currency = item?.pairs?.split("/")[1];
  const { t } = useTranslation();
  return (
    <TradeDetailListItemSection>
      <TradeText style={{ flexDirection: "column", alignItems: "center" }}>
        <Text>{item?.pairs}</Text>
        <Text style={{ color: "orange" }}>
          {item?.cross_iso === "C" ? t("cross") : t("iso")} {item?.leverage}X
        </Text>
      </TradeText>
      <TradeText style={{ }}>
        {BigNumber(item?.amount).multipliedBy(item?.leverage).toFormat(3)}
      </TradeText>
      <TradeText style={{}}>
        {item?.trade_price || item?.order_price} {currency}
      </TradeText>
      <TradeText style={{ flexDirection: "column", alignItems: "center", paddingLeft: '0.7%' }}>
        <Text>{item?.limit_market === "L" ? t("limit") : t("market")}</Text>
        {/* Time In Force 표시 (지정가 주문일 때만) */}
        {item?.limit_market === "L" && item?.time_in_force && (
          <Text style={{ fontSize: 11, color: item?.time_in_force === "GTD" ? COLORS.primary : COLORS.lightGray }}>
            {item?.time_in_force === "GTD" && item?.gtd_expiry
              ? `GTD ${dayjs(item?.gtd_expiry).format("MM/DD HH:mm")}`
              : item?.time_in_force}
          </Text>
        )}
      </TradeText>
      <TradeText
        style={{
          color: item?.long_short === "L" ? COLORS.lightGreen : COLORS.lightRed,
          paddingLeft: '1%'
        }}
      >
        {item?.long_short === "L" ? t("long") : t("short")}
      </TradeText>
      <TradeText style={{ paddingLeft: '1%' }}>
        {BigNumber(item?.margin).toFormat(3)} {currency}
      </TradeText>
      <TradeText style={{  }}>
        <KrwPrice
          dp={3}
          price={-BigNumber(item?.fee_price).toNumber()}
          krw={true}
        />
      </TradeText>
      <TradeText style={{ paddingLeft: '1%' }}>
        {useTimezone(item?.created_at, "YYYY-MM-DD HH:mm:ss", 0)}
      </TradeText>
    </TradeDetailListItemSection>
  );
};

export default React.memo(TradeDetailListItem)
